const strAccepted: string = 'hasApproved';
export default class Gateway {
	public element: HTMLElement = document.getElementById('cookiesNotification');

	private approve() {
		localStorage.setItem(strAccepted, 'true');
		(this.element).classList.remove('show');
		window.setTimeout(() => {this.setApproveFlag()}, 500);
	}
	private setApproveFlag() {
		this.element.remove();
	}
	private createEventHandlers() {
		const approveButton = (this.element).querySelectorAll('.cookiesNotification__link');

		for (var i = 0, l = approveButton.length; i < l; ++i) {
			approveButton[i].addEventListener('click', this.approve.bind(this));
		}
	}
	constructor() {
		if (!this.element) {
			return;
		}

		if (localStorage.getItem(strAccepted) === 'true') {
			this.setApproveFlag();
		} else {
			this.element.classList.add('show');
			this.createEventHandlers();
		}
	}
}